export const UsersMetricsActions = {
	GET_USER_METRICS: 'GET_USER_METRICS',
	GET_USER_METRICS_SUCCESS: 'GET_USER_METRICS_SUCCESS',
	GET_USER_METRICS_FAIL: 'GET_USER_METRICS_FAIL',
	CLEAR_METRICS_SESSION: 'CLEAR_METRICS_SESSION',
};
